module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class=\'salesforce-commerce-widget-settings integrations-setup\'>\n    <!--First row with the fields and informations-->\n    <section class="row">\n        <section class="col-xs-4">\n            <h4>Salesforce Commerce Cloud Product Widget</h4>\n            <p class="intro">With Creator\'s Salesforce Commerce Cloud Widget, you can search your Product Database from within the Editor and easily create QuickView links for your Creator Experiences.</p>\n\n            ';
 if (!isSalesforceCommerceEnabled && config.salesEmail) { ;
__p += '\n                <p>Get the Add-on by contacting <a href="mailto:' +
__e( config.salesEmail ) +
'">' +
__e( config.salesEmail ) +
'</a></p>\n            ';
 } ;
__p += '\n\n            ';
 if (isSalesforceCommerceEnabled && !permissionToManage) { ;
__p += '\n                <p>You must be a <a href="#manageAccount">Manager</a> to configure your Salesforce Commerce Cloud Account to work with Zmags Creator.</p>\n            ';
 } ;
__p += '\n\n            <div class="widget-icon">\n                <div class="illustration salesforce-commerce-widget-logo"></div>\n            </div>\n\n            ';
 if (!isSalesforceCommerceEnabled) { ;
__p += '\n                <div class="illustration salesforce-commerce-logo"></div>\n            ';
 } else {;
__p += '\n                <div class="notification-box">\n                    <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Enable Creator to connect to your Salesforce Commerce Cloud Account</span>\n                    <p>Find the instructions on how to configure your Salesforce Commerce Cloud OCAPI with Zmags Creator <a href="' +
__e( articleLink ) +
'" target="_blank" class="widget-community-link">here</a>.</p>\n                </div>\n            ';
 } ;
__p += '\n        </section>\n        ';
 if (isSalesforceCommerceEnabled) { ;
__p += '\n        <section class="col-xs-4">\n            <h4>1. Connect your Salesforce Commerce Cloud Account</h4>\n            ';
 if (permissionToManage) { ;
__p += '\n                <p>Type or copy your Salesforce Commerce Cloud credentials into the fields below:</p>\n            ';
 } ;
__p += '\n            <div class="form-group">\n                <label>Salesforce Commerce Cloud URL:</label>\n                <input type="text" class="form-control salesforceCommerceUrl" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += '\n                       id="salesforceCommerceUrl"\n                       placeholder="Type your Salesforce Commerce Cloud URL"/>\n            </div>\n\n            <div class="form-group">\n                <label>Client ID:</label>\n                <input type="text" class="form-control salesforceCommerceClientId" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += '\n                       id="salesforceCommerceClientId"\n                       placeholder="Type your Client ID"/>\n            </div>\n\n            <div class="form-group">\n                <label>Site IDs:</label><br/>\n                <div class="site-names' +
__e( permissionToManage ? '': ' disabled') +
'"></div>\n            </div>\n\n        </section>\n        <section class="col-xs-4">\n            <h4>2. Filter Product Information</h4>\n            ';
 if (permissionToManage) { ;
__p += '\n            <p>Configure Product information shown in the Salesforce Commerce Cloud Widget search results in the Editor:</p>\n            ';
 } ;
__p += '\n            <div class="row filters">\n                <div class="col-xs-6">\n                    <label>\n                        <input type="checkbox" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="availability"/> Availability\n                    </label>\n                    <label>\n                        <input type="checkbox" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="brand"/> Brand\n                    </label>\n                    <label>\n                        <input type="checkbox" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="description"/> Description\n                    </label>\n                </div>\n                <div class="col-xs-6">\n                    <label>\n                        <input type="checkbox" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="price"/> Price\n                    </label>\n                    <label>\n                        <input type="checkbox"  ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="name"/> Product Name\n                    </label>\n                </div>\n            </div>\n        </section>\n        ';
 } ;
__p += '\n    </section>\n\n    <!-- Save button -->\n    ';
 if (isSalesforceCommerceEnabled) { ;
__p += '\n        <section class="row">\n            <div class="col-xs-12">\n                <button class="btn btn-primary pull-right save ladda-button" data-style="expand-right" disabled>Save</button>\n            </div>\n        </section>\n    ';
 } ;
__p += '\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/settings/view/SalesforceCommerceWidgetSettingsView.tpl
// module id = 3057
// module chunks = 0